import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import FilterSearch from '../../components/filtersearch/FilterSearch';
import BookingTab from '../../components/bookingTabs/BookingTab';
import '../booking/Booking.css'
import EventTab from '../../components/eventsTabs/EventTab';
import PastTabs from '../../components/pastTabs/PastTabs';
import ExclusiveContent from '../../components/exclusiveContent/ExclusiveContent';

const Booking = () => {
  const [activeTab, setActiveTab] = useState(0); // Tracks the active tab
  return (
    <div className='dashboard-content-box'>
    <div className="tabs-container booking-sec">
      <div className='innerBooking-sec'>
        <div className="tabs-header d-flex flex-wrap justify-content-center align-items-center gap-2">
          <button className={`tab-button ${activeTab === 0 ? "active" : ""}`} onClick={() =>  setActiveTab(0)}> Bookings </button>
          <button className={`tab-button ${activeTab === 1 ? "active" : ""}`} onClick={() =>  setActiveTab(1)}> Events </button>
          <button className={`tab-button ${activeTab === 2 ? "active" : ""}`} onClick={() =>  setActiveTab(2)}> Requests </button>
          <button className={`tab-button ${activeTab === 3 ? "active" : ""}`} onClick={() =>  setActiveTab(3)}> Exclusive content </button>
          <button className={`tab-button ${activeTab === 4 ? "active" : ""}`} onClick={() =>  setActiveTab(4)}> Past </button>
          
          <div className="dropdown">
              <Link rel='stylesheet' className='dropdown-toggle  d-flex align-items-center gap-2 ' data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" aria-label="Toggle filter options">
                  <span className='icon-box'>
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.252 1H1.25195L8.94426 11.7692V21L13.5596 17.9231V11.7692L21.252 1Z" stroke="#787486" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  </span>
                </Link>
                <div class="dropdown-menu filter-menu">
                   <FilterSearch />
                </div>
            </div>
        </div>

        <div className="tabs-content BookingTabsSec">
          {activeTab === 0 && (
              <div className="tab-panel">
                 <BookingTab />
              </div>
          )}
          {activeTab === 1 && (
              <div className="tab-panel">
                <EventTab />
              </div>
          )}
          {activeTab === 2 && (
              <div className="tab-panel">
                c 
              </div>
          )}
          {activeTab === 3 && (
              <div className="tab-panel">
                <ExclusiveContent />
              </div>
          )}
          {activeTab === 4 && (
              <div className="tab-panel">
                <PastTabs />
              </div>
          )}
        </div>
      </div>
    </div>
  </div>
  )
}

export default Booking
